import { inTemporaryStore } from "./storage.util";

const POST_LOGIN_REDIRECT_KEY = "postLoginRedirectPath";

const toPathString = (location) => {
  if (!location?.pathname) return null;

  const search = location?.search || "";
  const hash = location?.hash || "";
  return `${location.pathname}${search}${hash}`;
};

export const savePostLoginRedirectPath = (location) => {
  const nextPath = toPathString(location);
  if (!nextPath || nextPath === "/forbidden") return;

  inTemporaryStore.setItem(POST_LOGIN_REDIRECT_KEY, nextPath);
};

export const consumePostLoginRedirectPath = () => {
  const nextPath = inTemporaryStore.getItem(POST_LOGIN_REDIRECT_KEY);
  inTemporaryStore.removeItem(POST_LOGIN_REDIRECT_KEY);
  return nextPath;
};

export const peekPostLoginRedirectPath = () =>
  inTemporaryStore.getItem(POST_LOGIN_REDIRECT_KEY);
